import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo10/votacion.png";
import Imagen2 from "../../../images/modulo10/proyectodeley.png";
import Imagen3 from "../../../images/modulo10/mesadirectiva.png";
import Imagen4 from "../../../images/modulo10/despacho.png";
import Imagen5 from "../../../images/modulo10/elperuano.png";
import Imagen6 from "../../../images/modulo10/firmaley.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo10 } from "../../../routes/Module10";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import Modulo10Act5 from "../../../DnD/modulo10Act5";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo10/Actividad 5.mp3";

const Actividad5 = () => {
  const infoUnidad = modulo10.content[0];
  const infoAct = modulo10.content[0].activities[4];
  const crumbs = [
    {
      title: modulo10.title,
      url: "/" + modulo10.url,
    },
    {
      title:
        modulo10.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo10.content[0].activities[5].name}`,
    linkNext: `${modulo10.url}/${modulo10.content[0].path}/${modulo10.content[0].activities[5].path}`,
    titlePrev: `${modulo10.content[0].activities[3].name}`,
    linkPrev: `${modulo10.url}/${modulo10.content[0].path}/${modulo10.content[0].activities[3].path}`,
  };

  const metadata = {
    color: modulo10.color,
    title: `${modulo10.title} - ${infoAct.name}`,
    name: modulo10.title,
  };

  const items = [
    <div className="p-3">
      <img src={Imagen1} alt="amigos" className="img-fluid" />
      <p className="text-center mt-3 mb-0">
        <strong>Los congresistas votan a favor de la ley.</strong>
      </p>
    </div>,
    <div className="p-3">
      <img src={Imagen2} alt="amigos" className="img-fluid" />
      <p className="text-center mt-3 mb-0">
        <strong>La congresista escribe un Proyecto de Ley.</strong>
      </p>
    </div>,
    <div className="p-3">
      <img src={Imagen3} alt="amigos" className="img-fluid" />
      <p className="text-center mt-3 mb-0">
        <strong>
          Los congresistas dan su opinión sobre la ley en el Congreso.
        </strong>
      </p>
    </div>,
    <div className="p-3">
      <img src={Imagen4} alt="amigos" className="img-fluid" />
      <p className="text-center mt-3 mb-0">
        <strong>La congresista escucha las ideas de los ciudadanos.</strong>
      </p>
    </div>,
    <div className="p-3">
      <img src={Imagen5} alt="amigos" className="img-fluid" />
      <p className="text-center mt-3 mb-3">
        <strong>Se publica la ley en diario oficial “El Peruano”.</strong>
      </p>
    </div>,
    <div className="p-3">
      <img src={Imagen6} alt="amigos" className="img-fluid" />
      <p className="text-center mt-3 mb-3">
        <strong>El Presidente de la República aprueba la ley.</strong>
      </p>
    </div>,
  ];

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo10.color} hat-text`}>
        <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul>
        <li>
          Los y las congresistas presentan “proyectos de ley”. Estos siguen un
          proceso hasta ser leyes aprobadas. Ahora ordenaremos algunos de los
          momentos de ese proceso.
        </li>
        <li>Arrastra las viñetas en los reacuadros numerado del 1 al 6: el 1 es lo que pasa primero y el 6 lo que pasa al final.</li>
       
      </ul>
      <Modulo10Act5 items={items} />

      <GuiaDocente>
        <p>
        Explique que las viñetas muestran, en desorden, los diferentes momentos que siguen los proyectos de ley. A partir del diálogo, ayude a ordenar las viñetas del 1 al 6. El orden correcto es 4, 2, 3, 1, 6, 5.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad5;
